/**
 * @author Angel Labrada Masso
 * @since v0.0.1
 * @date 05/08/2022
 */
import React, {memo} from 'react';
import PropTypes from 'prop-types';
import {Select} from 'antd';
import {useTranslation} from 'react-i18next';

const Option = Select;

const TemplateReportTypeSelect = ({value, onChange, ...props}) => {
  const {t} = useTranslation('templates');

  return (
    <div className='flex justify-start items-center w-full min-w-48'>
      <Select
        placeholder={t('form.placeholderTemplatePeriod')}
        optionFilterProp="children"
        onChange={onChange}
        defaultValue={value}
        value={value}
        className="custom-select w-full"
        {...props}
      >
        <Option value="Model_1">{t('Model_1')}</Option>
        <Option value="Model_2">{t('Model_2')}</Option>
        <Option value="Model_3">{t('Model_3')}</Option>
      </Select>
    </div>
  );
};

TemplateReportTypeSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

TemplateReportTypeSelect.defaultProps = {
  value: null
};

export default memo(TemplateReportTypeSelect);

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Date component in a table cell
 * @param {string} date this is value of de column
 * */
export const renderDateCell = ( date) => {
  return (
    <TemplateReportTypeSelect date={date}/>
  );
};
